
import React from 'react';

import SvgColor from '../svg-color/SvgColor';

export const path = {
    navbar: "navbar",
    common: "common",
    payment: "payment",
    profile: "profile",
    warehouse: "warehouse",
    logistic: "logistic",
}

export const icons = {

    add: ['ic_add', path.common],
    plus: ['ic_plus', path.common],
    minus: ['ic_minus', path.common],
    warning: ['ic_warning', path.common],
    tick: ['ic_tick', path.common],
    morevert: ['ic_morevert', path.common],
    chevronUp: ['ic_chevron_up', path.common],
    chevronDown: ['ic_chevron_down', path.common],
    chevronRight: ['ic_chevron_right', path.common],
    chevronLeft: ['ic_chevron_left', path.common],
    cancel: ['ic_cancel', path.common],
    edit: ['ic_edit', path.common],
    save: ['ic_save', path.common],
    remove: ['ic_remove', path.common],
    visible: ['ic_visible', path.common],
    invisible: ['ic_invisible', path.common],
    search: ['ic_search', path.common],
    refresh: ['ic_refresh', path.common],
    close: ['ic_close', path.common],
    setting: ['ic_cog', path.common],
    image: ['ic_image', path.common],
    blank: ['ic_blank', path.common],
    print: ['ic_print', path.common],
    calculator: ['ic_calculator', path.common],
    area: ['ic_area', path.common],
    duplicate: ['ic_duplicate', path.common],
    history: ['ic_history', path.common],
    default: ['ic_default', path.common],
    operations: ['ic_operation', path.common],
    info: ['ic_info', path.common],
    drag: ['ic_drag', path.common],
    redirect: ['ic_redirect', path.common],
    error: ['ic_error', path.common],
    success: ['ic_success', path.common],
    pdf: ['ic_pdf', path.common],
    cross: ['ic_cross', path.common],
    threshold: ['ic_threshold', path.common],
    dependency: ['ic_dependency', path.common],
    pending: ['ic_pending', path.common],
    translation: ['ic_translation', path.common],
    reset: ['ic_reset', path.common],
    table: ['ic_table', path.common],
    reservation: ['ic_reservation', path.common],
    queue: ['ic_queue', path.common],
    dineIn: ['ic_dine_in', path.common],
    loading: ['ic_loading', path.common],
    category: ['ic_category', path.common],
    undo: ['ic_undo', path.common],
    switch: ['ic_switch', path.common],
    contact: ['ic_contact', path.common],
    trip: ['ic_trip', path.common],
    maximise: ['ic_maximise', path.common],
    minimise: ['ic_minimise', path.common],
    transition: ['ic_transition', path.common],
    download: ['ic_download', path.common],
    upload: ['ic_upload', path.common],
    import: ['ic_import', path.common],
    calling: ['ic_calling', path.common],
    moveup: ['ic_moveup', path.common],
    movedown: ['ic_movedown', path.common],
    product: ['ic_product', path.common],
    hide: ['ic_hide', path.common],
    reveal: ['ic_reveal', path.common],
    newGrid: ['ic_newGrid', path.common],
    location: ['ic_location', path.common],

    creditcard: ['ic_creditcard', path.payment],
    ewallet: ['ic_ewallet', path.payment],
    cash: ['ic_cash', path.payment],
    pay: ['ic_pay', path.payment],
    currency: ['ic_currency', path.payment],
    discount: ['ic_discount', path.payment],
    equal: ['ic_equal', path.payment],
    percentage: ['ic_percentage', path.payment],
    transaction: ['ic_transaction', path.payment],

    mobile: ['ic_mobile', path.profile],
    email: ['ic_email', path.profile],
    profile: ['ic_profile', path.profile],

    warehouse: ['ic_warehouse', path.warehouse],
    package: ['ic_package', path.warehouse],
    smart: ['ic_smart', path.warehouse],
    instant: ['ic_instant', path.warehouse],
    override: ['ic_override', path.warehouse],
    transform: ['ic_transform', path.warehouse],
    moveRight: ['ic_move_right', path.warehouse],
    strictMode: ['ic_strict_mode', path.warehouse],

    transit: ['ic_transit', path.logistic],
    logistic: ['ic_logistic', path.logistic],
    destination: ['ic_destination', path.logistic],

    burger: ['ic_burger', path.navbar],
    members: ['ic_members', path.navbar],
    documents: ['ic_documents', path.navbar],
    products: ['ic_items', path.navbar],
    dashboard: ['ic_dashboard', path.navbar],
    cashSales: ['ic_cashsales', path.navbar],
    saleOrders: ['ic_salesorder', path.navbar],
    deliveryOrders: ['ic_deliveryorder', path.navbar],
    pickingOrders: ['ic_pickingorder', path.navbar],
    packingOrders: ['ic_packingorder', path.navbar],
    itemReceives: ['ic_itemreceive', path.navbar],
    itemTransfers: ['ic_itemtransfer', path.navbar],
    itemAdjustment: ['ic_itemadjustment', path.navbar],
    prescription: ['ic_prescription', path.navbar],
    examineProduct: ['ic_examineproduct', path.navbar],
    examineStorage: ['ic_examinestorage', path.navbar],
    users: ['ic_users', path.navbar],
    cart: ['ic_cart', path.navbar],
    blog: ['ic_blog', path.navbar],
    disabled: ['ic_disabled', path.navbar],
    report: ['ic_report', path.navbar],
    repository: ['ic_repository', path.navbar],
    group: ['ic_group', path.navbar],
    purchase: ['ic_purchase', path.navbar],
    sales: ['ic_sales', path.navbar],
    schedule: ['ic_schedule', path.navbar],
    identity: ['ic_identity', path.common],
    send: ['ic_send', path.common]
}

export function CommonIcons({ name, sx, ...others }) {

    const getIconPath = (name) => {
        return `/assets/icons/${name[1]}/${name[0]}.svg`
    }

    return (
        <SvgColor
            src={`${getIconPath(name)}`}
            sx={{
                width: 20,
                height: 20,
                ...sx
            }}
            {...others}
        />
    )
}

